import {
  PAYMENT_METHOD_MOMO,
  PAYMENT_METHOD_PAYOO_LIST,
} from "../common/constant";
import { IResponsePaging } from "../models/base";
import { order, payments } from "../repositories";
import { IOrder } from "./../models/orderModel";

export default {
  getOrders: async (
    query: any,
    callback: (data: IResponsePaging<IOrder[]>, err: any) => void
  ) => {
    try {
      const rs = await order.getOrders(query);
      callback(rs.data, null);
    } catch (error) {
      let empty: IResponsePaging<IOrder[]> = null;
      callback(empty, error);
    }
  },
  getOrder: async (id: any, callback: (data: any, err: any) => void) => {
    try {
      const rs = await order.getOrder(id);
      callback(rs.data, null);
    } catch (error) {
      let empty: any = null;
      callback(empty, error);
    }
  },
  retryPaymentOrder: async (query: any, cb: Function) => {
    const changePaymentMethodResponse = await order.changePaymentMethod({
      order_id: query?.order_id,
      payment_method: query?.payment_method,
    });

    if (
      changePaymentMethodResponse &&
      changePaymentMethodResponse.status === 200
    ) {
      if (PAYMENT_METHOD_PAYOO_LIST.indexOf(query?.payment_method) > -1) {
        const payooPaymentRetryResponse: any = await payments.payooPaymentRetry(
          {
            order_id: query?.order_id,
            kde_order_id: query?.kde_order_id,
            payment_method: query?.payment_method,
            source: "WEB",
          }
        );

        if (
          payooPaymentRetryResponse &&
          payooPaymentRetryResponse.status === 200
        ) {
          console.log("payooPaymentRetryResponse: ", payooPaymentRetryResponse);
          window.location.href =
            payooPaymentRetryResponse.data.order.payment_url;
        }
      } else if (query?.payment_method === PAYMENT_METHOD_MOMO) {
        const params = {
          order_id: query?.order_id,
          kde_order_id: query?.kde_order_id,
        };
        const result: any = await payments.signAndEncryptPaymentRequest(params);

        if (result.status == 200) {
          result.data.payment_method = PAYMENT_METHOD_MOMO;
          cb(result.data);
        }
      } else {
        cb({ payment_method: query?.payment_method });
      }
    }
  },
  rejectOrder: async (info: any, callback: (data: any, err: any) => void) => {
    try {
      const rs = await order.rejectOrder(info);
      callback(rs.data, null);
    } catch (error) {
      let empty: any = null;
      callback(empty, error);
    }
  },
  getIdOrderByCode: async (
    code: string,
    callback: (data: any, err: any) => void
  ) => {
    try {
      // const rs = await order.getIdOrderByCode(code);
      // callback(rs.data, null);
      callback(false, null);
    } catch (error) {
      callback(null, error);
    }
  },
};
